import { Component, OnInit, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { CollapsibleCardComponent } from '../../shared/components/collapsible-card/collapsible-card.component';
import { Schools } from 'src/app/core/models/schools';
import { SchoolsService } from '../../core/services/schools.service';

@Component({
  selector: 'app-school-card',
  templateUrl: './school-card.component.html',
  styleUrls: ['./school-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SchoolCardComponent implements OnInit {
  @Input() open: boolean;
  @Input() selectedSchoolId: string;
  used: false;
  schoolData: Schools;

  @ViewChild(MatTabGroup) accountTabs: MatTabGroup;
  @ViewChild(CollapsibleCardComponent)
  collapsibleCard: CollapsibleCardComponent;

  constructor(private schoolsService: SchoolsService) {}

  ngOnInit() {
    this.schoolsService.getSchoolsById(this.selectedSchoolId).subscribe(
      data => {
        this.schoolData = data;
      },
      error => {
        console.log(error);
      }
    );
  }
}
